import SoftBox from 'components/SoftComponents/SoftBox';
import React from 'react';
import SiteGroupForm from './groupForm';

const GroupSidebar = (props) => {
    // Dynamically filter the master devices array to extract full objects for the selected ones
    const selectedSites = props.allSites.filter((d) => props.selectedSiteIds.includes(d.properties.site_id));
    const selectedDevices = props.allDevices.filter((d) => props.selectedDeviceUUIDs.includes(d.properties.uuid));

    return (
        <SoftBox sx={{
            // Responsive flex widths ensuring sufficient room for large data
            width: { xxs: '100%', sm: '350px', md: '400px', lg: '450px', xl: '500px', xxl: '25vw' },
            maxWidth: { xxl: '600px' },
            flexShrink: 0,
            height: '100%', backgroundColor: '#f8f9fa',
            borderRight: { md: '1px solid #ddd' }, borderBottom: { xxs: '1px solid #ddd', md: 'none' },
            display: 'flex', flexDirection: 'column'
        }}>
            <SiteGroupForm 
                {...props} 
                selectedSites={selectedSites}
                selectedDevices={selectedDevices}
            />
        </SoftBox>
    );
};

export default GroupSidebar;